var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'py-1 px-2 d-flex justify-content-center align-items-center',
    _vm.$style.leagueNameWrapper,
    _vm.$style.nowrap
  ]},[_c('b-img',{staticClass:"mr-1",class:_vm.$style.leagueLogo,attrs:{"src":_vm.image}}),_c('div',{staticClass:"pl-2 d-flex flex-column flex-sm-row"},[_c('strong',[_vm._v(_vm._s(_vm.leagueName))]),_c('span',[_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v(" -")]),_vm._v("\n      "+_vm._s(_vm.roundName)+"\n    ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }